<template>
  <CChartBar
    :datasets="defaultDatasets"
    :options="defaultOptions"
    :labels="defaultLabels"
  />
</template>

<script>
import { CChartBar } from '@coreui/vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/utils/src'

export default {
  name: 'MainChartExample',
  components: {
    CChartBar
  },
  props:{
    chart_datas:Array,
  },
  computed: {
    defaultDatasets () {
      const brandInfo =  '#3399FF'

      const data1 = []
      for (let i = 0; i <= this.chart_datas.length; i++) {
     if(this.chart_datas[i]!= null){

       data1.push(this.chart_datas[i].qty)
     }

      }

      return [
        {
          label: 'Total Sale',
          backgroundColor: hexToRgba(brandInfo, 100),
          borderColor: brandInfo,
          pointHoverBackgroundColor: brandInfo,
          borderWidth: 2,
          data: data1
        },

      ]
    },
    defaultLabels () {
      var labels = [];
      for (let i = 0; i <= this.chart_datas.length; i++) {
        if(this.chart_datas[i]!= null) {

          labels.push(this.chart_datas[i].dayDate)
        }
      }
      return labels;
    },
    defaultOptions () {
      return {

        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            barPercentage: 0.4,
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 5,
              stepSize: Math.ceil(50 / 5),
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      }
    }
  }
}
</script>
